import { Steps } from "./salud-pymes-hire-menu-types";

export class SaludPymesHireMenuHelper {
  static getStepFromNavigationRoute(path: string): Steps {
    if (path.indexOf("/contratacion/nueva/salud-pymes/tomador") !== -1) return Steps.DatosTomador;
    else if (path.indexOf("/contratacion/nueva/salud-pymes/asegurados") !== -1)
      return Steps.DatosAsegurados;
    else if (path.indexOf("/contratacion/nueva/salud-pymes/garantias") !== -1)
      return Steps.Garantias;
    else if (path.indexOf("/contratacion/nueva/salud-pymes/documentacion-requerida") !== -1)
      return Steps.DocumentacionRequerida;
    else if (path.indexOf("/contratacion/nueva/salud-pymes/proteccion-datos") !== -1)
      return Steps.ProteccionDatos;
    else if (path.indexOf("/contratacion/nueva/salud-pymes/precio") !== -1) return Steps.Prima;
    else if (path.indexOf("/contratacion/nueva/salud-pymes/cuestionarios-salud") !== -1)
      return Steps.Cuestionarios;
    else if (path.indexOf("/contratacion/nueva/salud-pymes/medios-pago") !== -1)
      return Steps.MetodosPago;
    else if (path.indexOf("/contratacion/nueva/salud-pymes/resultado") !== -1)
      return Steps.DetallePrevioContratacion;
    else return Steps.DatosTomador;
  }

  static getStepNavigationPath(step: Steps, insuredsLength: number): string {
    let currentInsured = insuredsLength - 1;
    currentInsured = currentInsured < 0 ? 0 : currentInsured;
    switch (step) {
      case Steps.DatosTomador:
        return "/contratacion/nueva/salud-pymes/tomador";
      case Steps.DatosAsegurados:
        return insuredsLength === 0
          ? "/contratacion/nueva/salud-pymes/asegurados/"
          : `/contratacion/nueva/salud-pymes/asegurados/${currentInsured}`;
      case Steps.Garantias:
        return "/contratacion/nueva/salud-pymes/garantias";
      case Steps.DocumentacionRequerida:
        return "/contratacion/nueva/salud-pymes/documentacion-requerida";
      case Steps.ProteccionDatos:
        return "/contratacion/nueva/salud-pymes/proteccion-datos";
      case Steps.Prima:
        return "/contratacion/nueva/salud-pymes/precio";
      case Steps.Cuestionarios:
        return "/contratacion/nueva/salud-pymes/cuestionarios-salud/0";
      case Steps.MetodosPago:
        return "/contratacion/nueva/salud-pymes/medios-pago";
      case Steps.DetallePrevioContratacion:
        return "/contratacion/nueva/salud-pymes/resultado";
      default:
        return "";
    }
  }

  static getPreviousStep(currentStep: Steps): Steps {
    try {
      return currentStep - 1;
    } catch {
      return Steps.DatosTomador;
    }
  }

  static getPreviousStepNavigationPath(currentStep: Steps): string {
    return this.getStepNavigationPath(this.getPreviousStep(currentStep), 1);
  }

  static getNextStep(currentStep: Steps): Steps {
    try {
      return currentStep + 1;
    } catch {
      return Steps.DetallePrevioContratacion;
    }
  }

  static getNextStepNavigationPath(currentStep: Steps): string {
    return this.getStepNavigationPath(this.getNextStep(currentStep), 1);
  }
}
